import { Injectable } from '@angular/core';

import { AuthService, DataTransformService, RidangoEpic } from '@ridango/core';
import { CompanyHistoryTicket } from '../purchase-history.model';

import momenttz from 'moment-timezone';
import { ActionsObservable, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PurchaseHistoryService } from '../purchase-history.service';
import { PurchaseHistoryActions } from './purchase-history.actions';

@Injectable({
    providedIn: 'root'
})
export class PurchaseHistoryEpics implements RidangoEpic {
    constructor(
        private actions: PurchaseHistoryActions,
        private service: PurchaseHistoryService,
        private dataTransformer: DataTransformService,
        private authService: AuthService
    ) {}

    register() {
        return [this.getPurchaseHistory];
    }

    getPurchaseHistory = (action$: ActionsObservable<any>, state$: StateObservable<any>) =>
        action$.ofType(PurchaseHistoryActions.FETCH_PURCHASE_HISTORY).pipe(
            switchMap(() => {
                const start = state$.value.history.startDate;
                const end = state$.value.history.endDate;
                const companyId = this.authService.getLoggedInUserCompanyId();
                return this.service.fetchPurchaseHistory(start, end, companyId).pipe(
                    map((response) => {
                        const tickets = 'tickets' in response ? response.tickets : (response as CompanyHistoryTicket[]);

                        tickets
                            .sort((a, b) => {
                                const aDate = momenttz.tz(a.timestamp, 'Europe/Tallinn').toDate();
                                const bDate = momenttz.tz(b.timestamp, 'Europe/Tallinn').toDate();
                                if (aDate > bDate) {
                                    return -1;
                                } else if (aDate < bDate) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            })
                            .map((t) => {
                                if (!t.translations) {
                                    t.translations = [];
                                }
                                t.translations = t.translations.concat(
                                    this.dataTransformer.transformObjectTranslations(t, 'name')
                                );
                                t.translations = t.translations.concat(
                                    this.dataTransformer.transformObjectTranslations(t, 'short_name')
                                );
                                return t;
                            });

                        return this.actions.setTickets(tickets);
                    }),
                    catchError((error) => of(this.actions.getPurchaseHistoryFailed(error)))
                );
            })
        );
}
